import { ItemUnit } from '../../../models';
import { getRBPStringId } from '../../../page/main/main-page-states';
import http, { BASE_URL_3 } from '../../http';


const priceSpecificationApi = {

    // *********************
    //  菜品价钱规格
    // *********************
    /**
     * 获取价钱规格
     */
    async getPriceSpecification(rbpStringId?: string): Promise<ItemUnit[]> {
        const sid = (rbpStringId && rbpStringId.trim()) || getRBPStringId();
        return await http.get(`${BASE_URL_3}/dish/item_unit/${sid}`);
    },
    /**
     * 创建价钱规格
     */
    async postPriceSpecification(params: any): Promise<any> {
        return await http.post(`${BASE_URL_3}/dish/item_unit/${getRBPStringId()}`, params)
    },
    /**
     * 编辑价钱规格
     */
    async patchPriceSpecification(id: string, unit_name: string): Promise<any> {
        return await http.patch(`${BASE_URL_3}/dish/item_unit/${id}/${getRBPStringId()}?unit_name=${unit_name}`)
    },
    /**
     * 删除价钱规格
     */
    async delPriceSpecification(id: any): Promise<any> {
        return await http.delete(`${BASE_URL_3}/dish/item_unit/${id}/${getRBPStringId()}`,)
    },
    /**
     * 批量删除价钱规格
     */
    async delBatchPriceSpecification(ids: number[]): Promise<any> {
        return await http.delete(`${BASE_URL_3}/dish/item_unit/${getRBPStringId()}`, {
            data: ids
        })
    },
}
export default priceSpecificationApi;
